import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Text,
    Button,
    Link,
} from '@chakra-ui/react';

const STORAGE_KEY = 'vector-charts-disclaimer-accepted';
const landingPageUrl = import.meta.env.VITE_LANDING_PAGE_URL;

export const hasAcceptedDisclaimer = () => localStorage.getItem(STORAGE_KEY) === 'true';

const DisclaimerModal = ({ isOpen, onClose, requireAgreement }) => {
    const handleAgree = () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        onClose();
    };

    return (
        <Modal
            size="2xl"
            isOpen={isOpen}
            onClose={requireAgreement ? () => {} : onClose}
            closeOnEsc={!requireAgreement}
            closeOnOverlayClick={!requireAgreement}
            autoFocus={false}
            isCentered
        >
            <ModalOverlay />
            <ModalContent ml="10px" mr="10px" borderRadius="3px">
                <ModalHeader>Not for navigational use</ModalHeader>
                <ModalBody>
                    <Text fontSize="16px" mb="24px">
                        This web application is designed to demonstrate the capabilities of the{' '}
                        <Link href={landingPageUrl} isExternal color="blue.500" fontWeight="500" fontSize="16px" autoFocus={false}>
                            Vector Charts API
                        </Link>{' '}
                        and is not certified for navigational usage! <br/><br/>Use at your own risk and always consult your boat's primary navigation system.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    {requireAgreement ? (
                        <Button mr={0} onClick={handleAgree} variant="outline">
                            Agree &amp; Continue
                        </Button>
                    ) : (
                        <Button mr={0} onClick={onClose} variant="outline">
                            Close
                        </Button>
                    )}
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DisclaimerModal;
